<template>
  <v-container fluid pa-0 fill-height>
    <v-row class="fill-height ma-0">
      <v-col cols="12" md="6" class="align-center justify-center d-flex">
        <v-row justify="center">
          <template v-if="isLogin">
            <login-card
              :isAgent="true"
              @forgot-password="changePassword"
              @showLogin="showLogin"
              v-show="!forgotPassword"
            />
            <forgot-password
              v-show="forgotPassword"
              @backToLogin="changePassword"
            />
          </template>
          <template v-else>
          <donation-p-f @showLogin="showLogin"></donation-p-f>
          </template>
        </v-row>
      </v-col>
      <v-col md="6" class="login-image justify-center align-center">
        <img class="bg-img" :src="getCouncilBackgroundImage" />
        <v-layout column class="p-relative" fill-height z-1>
          <v-layout align-end text-center>
            <v-flex>
              <h1>
                Doar é super simples,
                <br />veja quais sao os passos:
              </h1>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex>

<!--              passo a passo Agente-->
              <div class="listagem" v-if="isLogin">
                <div class="listagem-item">
                  <span>1</span> Faça o seu cadastro e então efetue o login
                </div>
                <div class="listagem-item">
                  <span>2</span> Selecione a instituição a ser beneficiada, os
                  doadores, os respectivos valores e a forma de pagamento
                </div>
                <div class="listagem-item">
                  <span>3</span> Pague os boletos ou informe a transferência
                  realizada
                </div>
              </div>

<!--              passo a passo doação direta-->
              <div class="listagem" v-else>
                <div v-show="getPaymentMethod == null">
                  <div class="listagem-item">
                    <span>1</span> Preencha seus dados e escolha a forma de pagamento
                  </div>
                  <div class="listagem-item">
                    <span>2</span> Selecione a instituição e valor a ser doado
                  </div>
                  <div class="listagem-item">
                    <span>3</span> Pague o boleto ou informe a transferencia realizada
                  </div>
                </div>
                <div v-show="getPaymentMethod && getPaymentMethod.Id == 1">
                  <div class="listagem-item">
                    <span>1</span> Preencha seus dados
                  </div>
                  <div class="listagem-item">
                    <span>2</span> Selecione a instituição e valor a ser doado
                  </div>
                  <div class="listagem-item">
                    <span>3</span> Emita e recolha o boleto
                  </div>
                </div>

                <div v-show="getPaymentMethod && getPaymentMethod.Id == 2" v-if="this.council">
                  <div class="listagem-item">
                    <span>1</span> Faça o depósito ou transferência (TED, DOC, PIX etc.) para : Agência(Banco do Brasil): {{this.council.agency}}<br>
                    Conta Corrente: {{this.council.account}}-{{this.council.digit}} <br>CNPJ/PIX: {{ this.council.entityViewModel.document }}
                  </div>
                  <div class="listagem-item">
                    <span>2</span> Preencha seus dados
                  </div>
                  <div class="listagem-item">
                    <span>3</span> Selecione a instituição e valor a ser doado
                  </div>
                  <div class="listagem-item">
                    <span>4</span> Anexe a imagem do comprovante
                  </div>
                </div>

                <div v-show="getPaymentMethod && getPaymentMethod.Id == 3">
                  <div class="listagem-item">
                    <span>1</span> Faça a opção no Programa Gerador da
                    Declaração do Imposto sobre a Renda, emita e recolha o DARF
                  </div>
                  <div class="listagem-item">
                    <span>2</span> Preencha seus dados
                  </div>
                  <div class="listagem-item">
                    <span>3</span> Selecione a instituição e valor a ser doado
                  </div>
                  <div class="listagem-item">
                    <span>4</span> Anexe imagem do recolhimento do DARF
                  </div>
                </div>

              </div>

            </v-flex>
          </v-layout>
          <v-flex>
            <v-layout
              align-content-space-between
              justify-space-between
              column
              fill-height
            >
              <v-layout text-center>
                <v-flex>
                  <div class="pronto" v-if="getPaymentMethod && getPaymentMethod.Id == 1">
                    Pronto…
                    <br /> agora é só aguardar o envio do recibo <br> através do seu e-mail. 👍
                  </div>
                  <div class="pronto" v-else>
                    Pronto…
                    <br />fácil, rápido e simples. 👍
                  </div>
                </v-flex>
              </v-layout>
              <v-layout align-end>
                <v-flex class="copyright mt-5">
                  <p>
                    Copyright ©2021 - Benfeitores
                    <br />Todos os direitos reservados
                  </p>
                  <strong>Powered By Benfeitores</strong>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoginCard from "@/components/LoginCard";
import ForgotPassword from "@/components/ForgotCard";
import DonationPF from "@/components/Donation/DonationPF";
import EntityService from "@/scripts/services/entity.service";

export default {
  name: "HomeCouncil",
  inject: ["theme"],
  components: {
    LoginCard,
    ForgotPassword,
    DonationPF,
  },
  data: () => ({
    forgotPassword: false,
    isLogin: false,
    entityService: new EntityService(),
    council: null
  }),
  mounted() {
    this.entityService.getCouncilById(this.getCouncilId).then(data => (this.council = data))
  },
  methods: {
    changePassword() {
      this.forgotPassword = !this.forgotPassword;
    },
    showLogin(){
      this.isLogin = !this.isLogin;
    }
  },
  computed: {
    ...mapGetters(["getCouncilBackgroundImage","getPaymentMethod", "getCouncilId"]),
  }
};
</script>

<style lang="scss" scoped>
/* Título da pagina */
h1 {
  color: #ffffff;
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
}

.listagem {
  color: white;
  max-width: 440px;
  padding: 0 8px;
  font-family: mic-32-new-rounded-web, sans-serif;
  margin: 0 auto;
  .listagem-item {
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    padding: 16px 0;
    font-weight: 400;
    font-size: 130%;
    span {
      flex-shrink: 0;
      margin-right: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: #668df6;
      font-weight: 500;
      height: 33px;
      width: 33px;
      background-color: #ffffff;
    }
  }
}

.pronto {
  color: white;
  font-family: mic-32-new-rounded-web, sans-serif;
  font-size: 18px;
  line-height: 32px;
}

.copyright {
  color: white;
  font-size: 12px;
  text-align: right;
  padding: 32px;
  p {
    opacity: 0.8;
    font-size: 11px;
  }
  strong {
    font-weight: 300;
  }
}
</style>
